import React from 'react';
import ReactDOM from 'react-dom';
import './index.css'
import './themes/kickback/style.css'
import './themes/qa_regtest/style.css'
import './themes/fasrewards/style.css'
import './themes/harts/style.css'
import './themes/noco/style.css'
import './themes/jacksons/style.css'
import './themes/kbrewards/style.css'
import './themes/oasis/style.css'
import './themes/foodnfun/style.css'
import './themes/sprintmart/style.css'
import './themes/mrgas/style.css'
import './themes/refuel/style.css'
import './themes/foodnfuel/style.css'
import './themes/extramile/style.css'
import './themes/quickstop/style.css'
import './themes/millers/style.css'
import './themes/fleetway/style.css'
import './themes/rocket/style.css'
import './slider.css';
import App from './components/App';
import { Provider } from 'react-redux'
import createStore from './store/createStore'

const store = createStore();

ReactDOM.render(<Provider store={store}>
  <App/>
</Provider>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js